import { defaultRangeExtractor, Range } from "@tanstack/react-virtual";
import { useCallback, useRef } from "react";

import { calculateStickyRanges } from "./helpers";

const useStickyRangeExtractor = (stickyRangesIndexes: [number, number][]) => {
  const stickyGroupsVisibleOnTableRef = useRef<Map<number, number>>(new Map());

  // render the sticky rows even if they are outside the virtual range
  const rangeExtractor = useCallback(
    (range: Range) => {
      const defaultRange = defaultRangeExtractor(range);
      const visibleRange: [number, number] = [range.startIndex, range.endIndex];
      const { stickyGroups, newRange } = calculateStickyRanges(
        visibleRange,
        defaultRange,
        stickyRangesIndexes
      );

      stickyGroupsVisibleOnTableRef.current = stickyGroups;

      return newRange;
    },
    [stickyRangesIndexes]
  );

  return {
    stickyGroupsVisibleOnTableRef,
    rangeExtractor,
  };
};

export default useStickyRangeExtractor;
